import React from 'react';
import { LogOut, MessageCircle, IdCard } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { NavLink } from 'react-router-dom';

export function Sidebar({ menu }) {
  const { user, logout } = useAuth();

  return (
    <aside className="sidebar">
      <div className="brand">
        <img src="/logo.png" alt="Lumenfall" />
        <b>{user.type === 'professor' ? 'PAINEL DOCENTE' : 'PORTAL ACADÊMICO'}</b>
      </div>

      <nav className="nav">
        {menu.map(([label, Icon, path]) => (
          <NavLink 
            key={label} 
            to={path}
            className={({ isActive }) => isActive ? 'active' : ''}
          >
            <Icon size={20}/>{label}
          </NavLink>
        ))}
        
        {user.type === 'professor' && (
          <NavLink 
            to="/carteirinha"
            className={({ isActive }) => isActive ? 'active' : ''}
          >
            <IdCard size={20}/>Carteirinha Docente
          </NavLink>
        )}

        <div className="mt-4 pt-4 border-t border-white/5">
          <a 
            href="https://discord.gg/lumenfall" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-3 px-4 py-3 text-sm font-bold text-[#5865F2] bg-[#5865F2]/10 rounded-2xl hover:bg-[#5865F2]/20 transition-all"
          >
            <MessageCircle size={20}/> Discord Oficial
          </a>
        </div>
      </nav>

      <div className="userBox">
        <div>
          <strong className="text-white block truncate w-full">{user.name}</strong>
          <span className="text-purple font-black text-[10px] uppercase tracking-[2px] block mt-1">
            {user.enrollmentId || (user.type === 'professor' ? 'DOCENTE' : 'MATRÍCULA PENDENTE')}
          </span>
          <em className="text-muted text-[10px] font-bold uppercase tracking-wider block mt-1">
            {user.type === 'professor' ? 'Acesso Administrativo' : 'Portal Acadêmico'}
          </em>
        </div>
      </div>

      <button className="logout" onClick={logout}><LogOut size={18}/> Sair do Sistema</button>
    </aside>
  );
}
